<template>
  <checkbox-dropdown :checked-values="value"
                     :options="channelOptions"
                     :is-no-value-allowed="true"
                     grid-cols="2"
                     class="pt-5"
                     :hide-footer="true"
                     @change="onToggleCheckbox($event)"
  />
</template>

<script>
import conditionUtils from '@/utils/condition.utils'
import CheckboxDropdown from '@/components/common/CheckboxDropdown'
import { CONDITION_CASES } from '@/store/constants'

export default {
  name: 'ConditionCaseChannelType',

  components: { CheckboxDropdown },

  props: {
    value: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      channelOptions: [
        { name: 'Amio Chat', id: 'amio_chat', icon: 'amio-chat-icon-colored' },
        { name: 'Messenger', id: 'facebook_messenger', icon: 'messenger-icon-colored' },
        { name: 'WhatsApp', id: 'whatsapp', icon: 'whatsapp-icon-colored' }
      ]
    }
  },

  methods: {
    onToggleCheckbox(value) {
      this.$emit('input', conditionUtils.createConditionJson(CONDITION_CASES.CHANNEL_TYPE, value))
    }
  }
}
</script>
